package com.tovtalk.utils.share

import kotlin.coroutines.resume
import kotlin.coroutines.suspendCoroutine
import kotlinx.browser.window

actual object ShareHelper {
    actual suspend fun copyToClipboard(text: String): Boolean = suspendCoroutine { cont ->
        val nav = window.asDynamic().navigator
        val clipboard = nav?.clipboard
        if (clipboard != null && clipboard.writeText != null) {
            val p = clipboard.writeText(text) as kotlin.js.Promise<*>
            p.then(
                { cont.resume(true) },
                { cont.resume(false) }
            )
        } else {
            cont.resume(false)
        }
    }
}
